import { Controller } from "@hotwired/stimulus"

// Refreshes a dashboard widget's content frame as a turbo stream. Attached to
// the widget card (outside the replaced frame) so the timer and the header
// timestamp survive each refresh. With an interval value it polls — paused
// while the tab is hidden, catching up when it becomes visible again. The
// kebab menu's "Aktualisieren" triggers refresh() manually on any widget.
export default class extends Controller {
  static targets = ["timestamp"]
  static values = {
    url: String,
    interval: { type: Number, default: 0 },
  }

  connect() {
    this.lastRefreshedAt = null
    this.boundVisibilityChange = this.handleVisibilityChange.bind(this)
    document.addEventListener("visibilitychange", this.boundVisibilityChange)
    this.startTimer()
  }

  disconnect() {
    this.stopTimer()
    document.removeEventListener("visibilitychange", this.boundVisibilityChange)
  }

  startTimer() {
    if (this.intervalValue <= 0) return

    this.stopTimer()
    this.timer = setInterval(() => this.refresh(), this.intervalValue)
  }

  stopTimer() {
    if (this.timer) clearInterval(this.timer)
    this.timer = null
  }

  handleVisibilityChange() {
    if (document.hidden) {
      this.stopTimer()
    } else {
      if (this.intervalValue > 0 && this.stale()) this.refresh()
      this.startTimer()
    }
  }

  stale() {
    return !this.lastRefreshedAt || Date.now() - this.lastRefreshedAt > this.intervalValue
  }

  async refresh() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
      })
      if (response.ok) {
        Turbo.renderStreamMessage(await response.text())
        this.lastRefreshedAt = Date.now()
        this.updateTimestamp()
      }
    } catch {
      // Network hiccups are fine — the next interval retries.
    }
  }

  updateTimestamp() {
    if (!this.hasTimestampTarget) return

    const time = new Date(this.lastRefreshedAt).toLocaleTimeString("de-DE", {
      hour: "2-digit",
      minute: "2-digit",
    })
    this.timestampTarget.textContent = this.timestampTarget.dataset.template.replace(
      "%{time}",
      time,
    )
  }
}
